import { useState } from 'react';
import { Field } from 'formik';
import { FormControl, Stack, FormLabel, Box, Text } from '@chakra-ui/react';
import NameField from '@/components/forms/new/formikFormFields/NameField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import walkthroughIds from '../../../users/walkthroughIds';
import {
    stackSpacing,
    stackStyling,
    formLabelStyling,
} from 'components/forms/new/formStyles';

const ResourceAccountDisplayNameField = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { autoAttendant } = walkthroughIds;
    return (
        <FormControl
            isInvalid={!!errors.displayName && touched.displayName}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Display Name <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                </Box>
                <Field
                    component={NameField}
                    id="displayName"
                    name="displayName"
                    placeholder="Display Name"
                    data-walkthroughid={autoAttendant.ufDisplayName}
                    validate={(value) =>
                        !value ? 'Display name is required' : undefined
                    }
                />
                {isHovered && (
                    <FieldToolTip
                        label="Display Name of the Auto Attendant
Body text"
                        ariaLabel="resource-account-displayname-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default ResourceAccountDisplayNameField;
